// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions/index.tsx';
import { getSuggestedTopics, getPageNumber, getIsTopicsFiltered } from './selectors/index.tsx';
import type { State, Props } from './types.tsx';

const initialState: State = {
	topics: {
		data: [],
		loading: false,
		error: null,
	},
	isFiltered: true,
	page: 1,
};
export type ImmutableState = Readonly<State>;

export const store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'KnowledgeHubSuggestedTopicsStore',
});

export const KnowledgeHubSuggestedTopicsContainer = createContainer<State, Actions, Props>(store, {
	displayName: 'KnowledgeHubSuggestedTopicsContainer',
});

export const useSuggestedTopics = createHook(store, {
	selector: getSuggestedTopics,
});

export const usePageNumber = createHook(store, {
	selector: getPageNumber,
});

export const useIsTopicsFiltered = createHook(store, {
	selector: getIsTopicsFiltered,
});
